export default __webpack_public_path__ + "static/media/blogheadicon.e8786479.svg";